import { Component } from '@angular/core';
import { NavigationItem } from '@next/core-lib/navigation';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  navigationItems: NavigationItem[] = [
    {
      relativeUrl: '/reports',
      label: 'reports',
    },
    {
      relativeUrl: '/total-nitrogen-legal-norm',
      label: 'totalNitrogenLegalNorm',
    },
    {
      relativeUrl: '/legal-nitrogen-working-coefficient',
      label: 'legalNitrogenWorkingCoefficient',
    },
    {
      relativeUrl: '/crop-variety-specific-norm',
      label: 'cropVarietySpecificNorm',
    },
    {
      relativeUrl: '/phosphate-legal-norm',
      label: 'phosphateLegalNorm',
    },
    {
      relativeUrl: '/phosphate-legal-working-coefficient',
      label: 'phosphateLegalWorkingCoefficient',
    },
  ];
}
